<template>
  <a-modal v-model="visible" width="1000px" title="关联测试计划" ok-text="确认" cancel-text="取消" @ok="submit" @cancel="close">
    <a-card class="customer-filter" size="small">
      <a-form-model ref="modalForm" :form="filterForm" :label-col="{ span: 9 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="计划名称">
              <a-input v-model="filterForm.name" allow-clear placeholder="测试计划名称" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="测试负责人">
              <user-select v-model="filterForm.handlers" mode="multiple" allow-clear show-search placeholder="测试负责人" :project-id="projectId" @change="onSearch" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-alert v-if="[38, 94].includes(stepId)" type="info" show-icon style="margin-bottom: 5px">
      <span slot="message">只显示筛选类型为"<span style="color: green">研发自测</span>"且状态为"<span style="color: green">完成</span>"的测试计划</span>
    </a-alert>
    <a-card title="计划列表" size="small" class="filter-data">
      <a-table :scroll="{ x: 1600 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" :loading="loading" row-key="id" :row-selection="rowSelection" @change="handleTableChange">
        <span slot="testPlanName" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="custom-link" :href="planLink(record)" target="_blank"> {{ record.name }} </a>
          </a-tooltip>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag :color="testPlanStatus[record.status].color">{{ testPlanStatus[record.status].label }}</a-tag>
        </span>
        <span slot="progress" slot-scope="text, record">
          <a-progress :percent="record.progress" size="small" style="width: 130px" />
        </span>
        <span slot="casesProgress" slot-scope="text, record">
          <span style="padding-left: 30%">{{ record.finished_cases }}/{{ record.total_cases }}</span>
        </span>
        <span slot="type" slot-scope="text, record">
          {{ record.type ? testPlanTypes[record.type].label : '--' }}
        </span>
        <span slot="handlers" slot-scope="text, record">
          <span v-if="handlers(record).length !== 0">
            <a-popover placement="topLeft">
              <template slot="content">
                <span v-for="handler in handlers(record)" :key="handler.id">
                  <a-avatar :size="20" :src="handler.avatar_url" /> <span class="nickname">{{ handler.nickname }} </span>
                </span>
              </template>
              <span slot="title">处理人</span>
              <span v-for="handler in handlers(record)" :key="handler.id">{{ handler.nickname }}; </span>
            </a-popover>
          </span>
          <span v-else> -- </span>
        </span>
        <span slot="startTime" slot-scope="text, record">
          <test-plan-date-edit :data-source="record" item-name="start_time" @change="getPlanList" />
        </span>
        <span slot="endTime" slot-scope="text, record">
          <test-plan-date-edit :data-source="record" item-name="end_time" @change="getPlanList" />
        </span>
        <span slot="creator" slot-scope="text, record">{{ getUser(record.creator) }}</span>
      </a-table>
    </a-card>
  </a-modal>
</template>

<script>
import { testPlanList } from '@/api/project/testPlan';
import { bindWorkflowTestPlans } from '@/api/project/workflow';
import { testPlanTypes, testPlanStatus } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';
import TestPlanDateEdit from '@/pages/project/testplan/components/TestPlanDateEdit';

const columns = [
  {
    title: 'ID',
    dataIndex: 'key',
    key: 'key',
    width: 110,
    ellipsis: true
  },
  {
    title: '计划名称',
    width: 280,
    ellipsis: true,
    scopedSlots: { customRender: 'testPlanName' }
  },
  {
    title: '状态',
    width: 110,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '测试进度',
    width: 150,
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '已完成/总数',
    width: 110,
    scopedSlots: { customRender: 'casesProgress' }
  },
  {
    title: '测试类型',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '测试负责人',
    width: 150,
    align: 'center',
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '开始时间',
    width: 150,
    align: 'center',
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '结束时间',
    width: 150,
    align: 'center',
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '创建人',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'creator' }
  }
];

export default {
  name: 'WorkflowTesPlanModal',
  components: { UserSelect, TestPlanDateEdit },
  props: {
    projectId: {
      type: [Number, String],
      default: null
    },
    workflowId: {
      type: [Number, String],
      default: null
    },
    stepId: {
      type: [Number, String],
      default: null
    },
    defaultPlans: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns,
      testPlanTypes,
      testPlanStatus,
      visible: false,
      filterForm: {
        name: '',
        page_size: 10,
        page_number: 1,
        time_field: 'start_time',
        handlers: []
      },
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: []
    };
  },
  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    },
    handlers() {
      return record => {
        return record.handlers || null;
      };
    },
    planLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        });
        return route.href;
      };
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: record => ({
          props: {
            disabled: record.disabled
          }
        })
      };
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler(val) {
        this.visible = val;
        if (val) {
          this.getPlanList();
        }
      }
    },
    visible: {
      handler(val) {
        this.$emit('update:isShow', val);
      }
    },
    stepId: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          this.getPlanList();
        }
      }
    },
    defaultPlans: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.selectedRowKeys = val.map(plan => plan.id);
        }
      }
    }
  },
  created() {
    // this.getPlanList();
  },
  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.filterForm.page_number = 1;
      this.getPlanList();
    },
    getPlanList() {
      this.loading = true;
      const planType = [1, 2, 3, 4, 5];
      // if ([38, 94].includes(this.stepId)) {
      //   this.filterForm.status = [3];
      //   this.filterForm.finished = true;
      // } else {
      //   this.filterForm.status = [];
      //   // this.filterForm.finished = false;
      // }
      testPlanList({ ...this.filterForm, project_id: this.projectId, type: planType })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getPlanList();
    },
    submit() {
      this.$emit('test-plan-change', this.selectedRows);
      // bindWorkflowTestPlans({
      //   project_id: this.projectId,
      //   workflow_id: this.workflowId,
      //   test_plans: this.selectedRows
      // }).then(() => {
      //   this.$message.success("关联工作流测试计划成功");
      //   this.$emit("close");
      // })
    },
    close() {
      this.$refs.modalForm.resetFields();
      this.$emit('close');
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }

  margin-bottom: 16px;

  .ant-form-item {
    margin-bottom: 8px;
    display: flex;

    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }

  .filter-right {
    float: right;
    text-align: right;
  }
}
</style>
